import React from 'react';
import SideBarNav from '../Layout/SideBarNav/SideBarNav';

import { Box} from '@mui/material';
import { Container } from '@mui/material';
// TextField
import Grid from '@mui/material/Grid';

import BasicCard from '../Features/Components/BasicCard';

//Banks
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
//Inspector
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
//Builder
import ConstructionIcon from '@mui/icons-material/Construction';
// import AddIcon from '@mui/icons-material/Add';
import GiteIcon from '@mui/icons-material/Gite';
import EngineeringIcon from '@mui/icons-material/Engineering';


export default function AdminUserLandingPage() {

  const BanksInfo = [
    {
      key:0,
      cardHeader:"Banks",
      iconToDisplay: <AccountBalanceIcon/>,
      optionsToChoose:[
        {
          optionText:"Add / Update Bank",
          optionIcon: <AttachMoneyIcon/>,
          optionLinkTo:"/AddUpdateBank"

          
        },
        {
          optionText:"Add / Update Bank Branch",
          optionIcon: <AccountBalanceIcon/>,
          optionLinkTo:"/BankBranchTabsPage"
        },
        {
          optionText:"Add / Update Branch Employee",
          optionIcon: <PlaylistAddCircleIcon/>,
          optionLinkTo:"/AddUpdateBankEmployeePage"
        }
      ]
    },
    {
      key:0,
      cardHeader:"Inspectors",
      iconToDisplay: <AccountBalanceIcon/>,
      optionsToChoose:[
        {
          optionText:"Add / Update Inspection Agency",
          optionIcon: <ContentPasteIcon/>,
          optionLinkTo:"/AddUpdateInspectionHQ"
        },
        {
          optionText:"Add / Update Inspection Branch",
          optionIcon: <MapsHomeWorkIcon/>,
          optionLinkTo:"/AddUpdateinspectionBranch"
        },
        {
          optionText:"Add / Update Branch Employee",
          optionIcon: <PersonAddAltIcon/>,
          optionLinkTo:"/AddUpdateinspectionAgencyEE"
        }
      ]
    },
    {
      key:0,
      cardHeader:"Builder",
      iconToDisplay: <AccountBalanceIcon/>,
      optionsToChoose:[
        {
          optionText:"Add / Update Builder Agency",
          optionIcon: <ConstructionIcon/>,
          optionLinkTo:"/AddUpdateBuilderHQ"
        },
        {
          optionText:"Add / Update Builder Branch",
          optionIcon: <GiteIcon/>,
          optionLinkTo:"/AddUpdateBuilderBranch"
        },
        {
          optionText:"Add / Update Builder Employee",
          optionIcon: <EngineeringIcon/>,
          optionLinkTo:"/AddUpdateBuilderEE"
        }
      ]
    }
]
  return (
    <Box>
        <h1>AdminUserLandingPage</h1>
        <SideBarNav/>
        <Container>
          <Grid container spacing={2} sx={{mt:'12.5%',pl:'5vh'}}>
            
              {BanksInfo.map((bankObj) =>{
                return (
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <BasicCard props={bankObj}/>
                  </Grid>
                )
              })}
                
            
          </Grid>

        </Container>
        
    </Box>
  )
}
